<template>
  <div>
    <div v-if="this.$store.state.device.isDesktop">Desktop Mode is currently in development</div>
    <div id="init" v-if="this.$store.state.device.isMobile" class="background" style="background-color: #2B2D42;height: 100%;width: 100%; position: absolute">
      <navbarTopMenu></navbarTopMenu>
      <div style="padding: 20px 20px 0; z-index: 1500;">
        <b-row style="width: 100%;margin: auto;padding-top: 20%;"><router-link class="route" to="/dashboard">{{ $t('pages.Menu.Dashboard') }}</router-link></b-row>
        <b-row class="route_border"><router-link class="route" to="/createSocio">{{ $t('pages.Menu.Registration') }}</router-link></b-row>
        <b-row class="route_border"><router-link class="route" to="/listSocios">{{ $t('pages.Menu.List') }}</router-link></b-row>
        <b-row class="route_border"><router-link class="route" to="/listPayments">{{ $t('pages.Menu.Payments') }}</router-link></b-row>
        <b-row class="route_border"><router-link class="route" to="/csv">{{ $t('pages.Menu.DownloadCsv') }}</router-link></b-row>
        <b-row class="route_border"><router-link class="route" to="/suporte">{{ $t('pages.Menu.Support') }}</router-link></b-row>
        <b-button v-on:click="logout" class="btnLogout"><b>Log out</b></b-button>
        <div style="padding-top: 5%; padding-bottom: 10%;">
          <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': 'white'}]">PT</a>
          <span class="lang_seperator">|</span>
          <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': 'white'}]">EN</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavbarTopMenu from "../components/navbarTop_Menu";
  import navbarBottom from "../components/navbarBottom";
  export default {
    name: "init_menu",
    components: { NavbarTopMenu, navbarBottom },
    data() {
      return {
        pt: null,
        en: null
      };
    },
    methods: {
      changeToEn: function() {
        this.$i18n.set('en');
        this.en = true;
        this.pt = false;
      },
      changeToPt: function() {
        this.$i18n.set('pt');
        this.en = false;
        this.pt = true;
      },
      logout: function() {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('color');
        localStorage.removeItem('image');
        localStorage.removeItem('organization');
        localStorage.removeItem('members');
        localStorage.setItem('language', 'pt');
        this.$router.push("/");
      }
    },
    mounted() {
      if(this.$i18n.locale()=='pt') this.pt=true;
      if(this.$i18n.locale()=='en') this.en=true;
    }
  };
</script>

<style scoped>
  div {
    background-color: #2B2D42;
  }
  .lang {
    color: white;
    letter-spacing: 0.8px;
    font-size: 100%;
  }
  .lang_seperator {
    margin: 10px;
    color: white;
  }
  .btnLogout {
    margin-top: 5%;
    height: 55px;
    width: 100%;
    background: white 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: #1e90ff;
    border: none;
    font-size: 18px;
  }
  .route {
    margin: 20px 30px;
    font-size: 18px;
    color: white;
    letter-spacing: 0.8px;
  }
  .route_border {
    border-top: 0.5px solid #8D99AE;
    width: 100%;
    margin: auto;
  }

</style>
